export const pageRoutes = {
    login: '/',
    dummy: '/dummy',
    dashboard: '/dashboard',
    chat: "/chat",
    invoice:'/invoice'

}